import { useEffect, useState } from 'react';
import {
  delDownLoadVersion,
  getDownLoadItems,
  getDownLoadVersionItems,
} from '../../../api';
import { messageError, messageSuccess } from '../../../components/message';
import {
  IDownLoadType,
  IDownLoadVersionMenu,
} from '../../../model/api-modules';
import { DownloadVersionTable } from './lib/download-version-table';
import warnImage from '../../../assets/images/warn-yellow.png';
import { DownLoadVersionDrawer } from './download-version-drawer';
import getFormatMessage from '../../../locales/get-format-message';
import styles from './index.module.scss';
import {
  getFirstManageSite,
  getNeedManageSites,
  getNeedManageSitesWithSync,
  getNeedSynSiteOptions,
} from '../../../lib/multi-site';
import { wrapRequestArea } from '../../../lib/http/lib';
import { ISiteIDownLoadMenu } from './download-items';
import {
  getDownloadVersionMatcher,
  handleMultiSiteSubmitRes,
  multiSiteSubmitter,
  syncVersionToSite,
} from './lib/multi-site-helper';
import { initDownloadCos } from './lib/multi-site-cos';
import {
  CommonAddButton,
  CommonButtonGroup,
  MainButton,
} from '../../../components/button/main';
import { ModalWrap } from '../../../components/modal-wrap';
import { showSyncModal } from '../lib/sync-helper';

export type ISiteIDownLoadVersionMenu = Record<string, IDownLoadVersionMenu[]>;

interface IProps {
  readonly currentTab: string;
}

export const DownLoadVersions = (props: IProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [downLoadVersionList, setDownLoadVersionList] = useState<
    IDownLoadVersionMenu[]
  >([]);
  const [allSiteDownLoadVersionList, setAllSiteDownLoadVersionList] =
    useState<ISiteIDownLoadVersionMenu>({});
  const [allSiteDownLoadList, setAllSiteDownLoadList] =
    useState<ISiteIDownLoadMenu>({});
  const [row, setRow] = useState<IDownLoadVersionMenu | null>(null);
  const [editType, setEditType] = useState<IDownLoadType>();
  const [delRow, setDelRow] = useState<IDownLoadVersionMenu | null>(null);

  const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]);

  useEffect(() => {
    initDownloadCos();
  }, []);

  const getDownLoadVersionList = async () => {
    setLoading(true);
    const allSites = getNeedManageSitesWithSync();

    const currentList: ISiteIDownLoadVersionMenu = {};

    await Promise.all(
      allSites.map(async (siteName) => {
        const res = await wrapRequestArea(getDownLoadVersionItems, siteName);
        currentList[siteName] = res || [];
      })
    );
    setAllSiteDownLoadVersionList(currentList);

    setDownLoadVersionList(currentList[getFirstManageSite()] || []);
    console.log(111, currentList[getFirstManageSite()]);
    setLoading(false);
    getAllSiteDownloadList();
  };

  const getAllSiteDownloadList = async () => {
    const allSites = getNeedManageSites();
    const currentObjectList: ISiteIDownLoadMenu = {};
    await Promise.all(
      allSites.map(async (siteName) => {
        const res = await wrapRequestArea(getDownLoadItems, siteName);
        currentObjectList[siteName] = res || [];
      })
    );
    setAllSiteDownLoadList(currentObjectList);
  };
  const onDel = (record: IDownLoadVersionMenu) => {
    setDelRow(record);
  };
  const onView = (record: IDownLoadVersionMenu) => {
    setRow(record);
    setEditType(IDownLoadType.View);
  };
  const onEdit = (record: IDownLoadVersionMenu) => {
    setRow(record);
    setEditType(IDownLoadType.Edit);
  };
  const onCopy = (record: IDownLoadVersionMenu) => {
    const getNextVersion = () => {
      const versionNumbers = record.Version.split('.');
      const lastNum = Number(versionNumbers.pop());
      if (!isNaN(lastNum)) {
        return [...versionNumbers, lastNum + 1].join('.');
      }
      return '1.0.0';
    };
    setRow({ ...record, Version: getNextVersion() });
    setEditType(IDownLoadType.Create);
  };
  const onAdd = () => {
    setEditType(IDownLoadType.Create);
  };
  const onClose = (success?: boolean) => {
    setRow(null);
    setDelRow(null);
    setEditType(undefined);
    if (success) {
      getDownLoadVersionList();
    }
  };
  const confirmDel = async () => {
    if (delRow) {
      const res = await multiSiteSubmitter((matchRow: IDownLoadVersionMenu) => {
        return delDownLoadVersion(matchRow.id);
      }, getDownloadVersionMatcher(delRow, allSiteDownLoadList, allSiteDownLoadVersionList));

      return handleMultiSiteSubmitRes(res, {
        onSuccess: () => {
          getDownLoadVersionList();
          onClose(true);
        },
        successMessage: getFormatMessage('del_success'),
        errorMessage: getFormatMessage('error_delete'),
      });
    }
    messageError(getFormatMessage('error_delete'));
    return false;
  };

  const onSync = () => {
    showSyncModal(onSyncEnvs);
  };

  const onSyncEnvs = async (syncSite: string) => {
    const modalInstance = ModalWrap.show({
      title: '同步版本',
      children: '同步中,请不要关闭页面',
      maskClosable: false,
    });

    const res = await syncVersionToSite(selectedRowKeys, syncSite);
    modalInstance.destroy();
    if (res.res) {
      messageSuccess(getFormatMessage('sync_success'));
      return true;
    }
    messageError(`${getFormatMessage('sync_fail')} ${res.message}`);

    return false;
  };

  const renderDelModal = () => {
    if (delRow) {
      // const name = delRow.ObjectID;
      return (
        <ModalWrap
          onOk={confirmDel}
          onClose={() => onClose(false)}
          cancelText={getFormatMessage('cancel')}
          oKText={getFormatMessage('delete')}
          width="480px"
          title={
            <p className="fail-title">
              <img
                src={warnImage}
                style={{ marginRight: '10px', marginTop: '-2px' }}
              />
              <span>{getFormatMessage('delete_version')}</span>
            </p>
          }
          className="delete-modal"
        >
          <div>
            {getFormatMessage('del_version_sure_desc')}
            {delRow.Version}?
          </div>
        </ModalWrap>
      );
    }
    return null;
  };

  const renderDownLoadVersionDrawer = () => {
    if (editType) {
      return (
        <DownLoadVersionDrawer
          allSiteDownLoadList={allSiteDownLoadList}
          allSiteDownLoadVersionList={allSiteDownLoadVersionList}
          row={row}
          onClose={onClose}
          type={editType}
        />
      );
    }
    return null;
  };
  useEffect(() => {
    getDownLoadVersionList();
  }, [props.currentTab]);

  return (
    <>
      <div className={styles.pageActions}>
        <CommonButtonGroup>
          <CommonAddButton onClick={onAdd}>
            {getFormatMessage('create_version')}
          </CommonAddButton>
          {getNeedSynSiteOptions().length > 0 && (
            <MainButton
              onClick={onSync}
              disabled={selectedRowKeys.length === 0}
            >
              {getFormatMessage('同步至其它站点')}
            </MainButton>
          )}
        </CommonButtonGroup>
      </div>
      <DownloadVersionTable
        allSiteDownLoadList={allSiteDownLoadList}
        allSiteDownLoadVersionList={allSiteDownLoadVersionList}
        getDownLoadVersionList={getDownLoadVersionList}
        loading={loading}
        downLoadVersionList={downLoadVersionList || []}
        onEdit={onEdit}
        onView={onView}
        onDel={onDel}
        onCopy={onCopy}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
      {renderDownLoadVersionDrawer()}
      {renderDelModal()}
    </>
  );
};
